export var SettingsQueryKey;
(function (SettingsQueryKey) {
    SettingsQueryKey["CompanySettings"] = "CompanySettings";
    SettingsQueryKey["HrmSettings"] = "HrmSettings";
    SettingsQueryKey["DocumentSettings"] = "DocumentSettings";
    SettingsQueryKey["CompanyTemplates"] = "CompanyTemplates";
    SettingsQueryKey["SsoSettings"] = "SsoSettings";
})(SettingsQueryKey || (SettingsQueryKey = {}));
